import __vue_normalize__ from 'vue-runtime-helpers/dist/normalize-component.mjs';
import script from './HseTabs.vue_rollup-plugin-vue=script.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hse-Tabs",class:( _obj = {}, _obj[("hse-Tabs_variant_" + _vm.variant)] = _vm.variant, _obj[("hse-Tabs_style_" + _vm.tabStyle)] = _vm.tabStyle, _obj )},_vm._l((_vm.tabs),function(item){
  var _obj, _obj$1;
return _c('button',{key:item.value,staticClass:"hse-TabsItem",class:( _obj = {
      'hse-TabsItem_selected': item.value === _vm.selected,
      'hse-TabsItem_disabled': item.disabled
    }, _obj[("hse-TabsItem_variant_" + _vm.variant)] = _vm.variant, _obj[("hse-TabsItem_style_" + _vm.tabStyle)] = _vm.tabStyle, _obj[_vm.classes.item] = _vm.classes.item, _obj ),attrs:{"disabled":item.disabled,"type":"button"},on:{"blur":function($event){_vm.focusedItem = null;},"click":function($event){return _vm.onClick(item)},"focus":function($event){_vm.focusedItem = item.value;},"mouseout":function($event){_vm.hoveredItem = null;},"mouseover":function($event){!item.disabled && (_vm.hoveredItem = item.value);}}},[_vm._v("\n    "+_vm._s(item.label)+"\n    "),(item.counter)?_c('HseBadgeLabel',{staticClass:"hse-TabsItem__counter",class:( _obj$1 = {
        'hse-BadgeCounter_hover': item.value === _vm.selected
      }, _obj$1[_vm.classes.itemCounter] = _vm.classes.itemCounter, _obj$1 ),attrs:{"disabled":item.disabled,"hover":_vm.variant === 'line' && _vm.hoveredItem === item.value,"selected":item.value === _vm.selected || _vm.focusedItem === item.value,"size":"small"}},[_vm._v("\n      "+_vm._s(item.counter)+"\n    ")]):_vm._e()],1)}),0)};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;
